import { gql } from '@apollo/client';
import { getClient } from '../client-graphql';
import { PagePersonFragmentFragment } from '@fm-nx/contentful-types';
import { ImageWrapperFragment } from './fragments/fragment-image-wrapper';

export const PagePersonFragment = gql(`
    fragment PagePersonFragment on PagePerson {
        __typename
        sys {
            id
        }
        slug
        seoTitle
        seoDescription
        title
        heroImage {
            ...ImageWrapperFragment
        }
        isActive
        person {
            sys {
                id
            }
        }
    }
`);

type PersonQueryResponse = {
    pagePersonCollection?: {
        items: PagePersonFragmentFragment[];
    };
};

export async function getPagesPersonBare(props: { limit?: number; preview?: boolean } = {}) {
    const { limit, preview = false } = props;
    const { data } = await getClient(preview).query<PersonQueryResponse>({
        query: gql`
            query GetPagesPersonAll($preview: Boolean, $limit: Int) {
                pagePersonCollection(preview: $preview, limit: $limit, where: { isActive: true }) {
                    items {
                        __typename
                        sys {
                            id
                        }
                        slug
                    }
                }
            }
        `,
        variables: {
            preview,
            ...(limit !== undefined && { limit }),
        },
    });
    return data?.pagePersonCollection?.items ?? [];
}

export async function getPagePersonBySlug(slug: string, preview = false) {
    const { data } = await getClient(preview).query<PersonQueryResponse>({
        query: gql`
            query GetPersonBySlug($slug: String!, $preview: Boolean) {
                pagePersonCollection(where: { slug: $slug, isActive: true }, preview: $preview) {
                    items {
                        ...PagePersonFragment
                    }
                }
            }
            ${PagePersonFragment}
            ${ImageWrapperFragment}
        `,
        variables: {
            slug,
            preview,
        },
    });
    return data?.pagePersonCollection?.items?.[0];
}
